// Tenantra Inc. - Shared payment labels and formatting for landlord Payments, Transactions and tenant Billing
export const money = (n) => `$${Number(n || 0).toLocaleString('en-CA', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
export const PAY_STATUS = {
  paid: ['Paid', 'emerald'], settled: ['Paid', 'emerald'], processing: ['Processing', 'amber'], requested: ['Waiting for Interac', 'amber'],
  scheduled: ['Scheduled', 'teal'], returned: ['Returned (NSF)', 'red'], failed: ['Failed', 'red'], cancelled: ['Cancelled', 'slate'],
  partial: ['Partial', 'amber'], late: ['Late', 'red'], not_paid: ['Not paid', 'slate'],
};
export const METHOD = {
  bank: 'Bank (PAD)', interac: 'Interac', credit_card: 'Credit card', debit_card: 'Visa debit',
  eft: 'EFT', interac_anr: 'Interac ANR', interac_send: 'Interac Send',
};
